import { Component } from 'react';

import s from './Search.module.scss';

class Search extends Component {
	render() {
		const { onSearchChange } = this.props;

		return (
			<div className={s.search}>
				<input type="text" placeholder="Type to search..." onChange={(e) => onSearchChange(e.target.value)} />
			</div>
		);
	}
}

export default Search;
